module.exports = __webpack_public_path__ + "static/learn2-502304100988d74c5729b534976c3e57.jpeg";